import React from "react";
import { Form } from "react-bootstrap";
import PopoverBtn, { IPopoverBtnProps } from "../popoverBtn";

type Props = {
  controlId: string;
  label?: string;
  checked: boolean;
  onChange: () => void;
  className?: string;
  textClasses?: string;
  tooltip?: IPopoverBtnProps;
  disabled?: boolean;
};

export const StyledCheckbox = ({
  controlId,
  label,
  checked,
  onChange,
  className = "",
  tooltip,
  disabled = false,
}: Props) => {
  return (
    <Form.Group
      controlId={controlId}
      className={`d-flex align-items-center ${className}`}
    >
      <Form.Check.Input
        type="checkbox"
        className="m-0 me-2"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <Form.Check.Label className="text-dark-gray fw-bold me-2">
        {label}
      </Form.Check.Label>
      {tooltip?.text && <PopoverBtn {...tooltip} />}
    </Form.Group>
  );
};
